module.exports = __webpack_public_path__ + "img/GAME_CARDRIVE.80351a1a.png";